<agr-dialog class="growth-stage-dialog" [data]="data" [formGroup]="form" (cancel)="cancel()">
  <ng-container details>
    <div class="flex--row">
      <div class="spacing--margin-right">
        <mat-chip-listbox>
          @for (cropFieldId of selectedCropFieldIds; track cropFieldId) {
            <mat-chip-option [selectable]="false" (removed)="removeCropField(cropFieldId)">
              <b>{{ getCropFieldName(cropFieldId) }}</b> {{ getCropFieldArea(cropFieldId) }} ha
              @if (!isReadonlyMode && selectedCropFieldIds.length > 1) {
                <mat-icon matChipRemove data-test="crop-remove">cancel</mat-icon>
              }
            </mat-chip-option>
          }
        </mat-chip-listbox>
      </div>
    </div>
  </ng-container>

  <div class="dialog spacing--margin-top">
    <div class="growth-stage-add-section">
      <div class="section-title spacing--margin-half-bottom">
        {{ 'downyMildew.growthPhase.addSectionTitle' | translate }}
      </div>

      <!-- Date picker -->
      <div class="flex--row flex--gutter spacing--margin-half-top">
        <div class="flex__child">
          <mat-form-field class="full-width-field" data-test="growth-stage-date">
            <mat-label>{{ 'downyMildew.growthPhase.date' | translate }}</mat-label>
            <input
              matInput
              formControlName="date"
              [matDatepicker]="growthStageDatePicker"
              [max]="maxDate"
              [placeholder]="'downyMildew.growthPhase.date' | translate"
              [errorStateMatcher]="dateErrorStateMatcher"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="growthStageDatePicker"
              [disabled]="isReadonlyMode"
            ></mat-datepicker-toggle>
            <mat-datepicker #growthStageDatePicker></mat-datepicker>
            @if (form.controls.date.hasError('matDatepickerMax')) {
              <mat-error data-test="growth-stage-date-future-error">{{
                'downyMildew.growthPhase.dateInFuture' | translate
              }}</mat-error>
            }
          </mat-form-field>
        </div>
      </div>

      <!-- Major growth stages -->
      <div class="spacing--margin-top">
        <div class="text--bold spacing--margin-half-bottom">
          {{ 'downyMildew.growthPhase.selectMajorStage' | translate }}
        </div>
        <mat-radio-group formControlName="majorStage" class="major-stage-group" data-test="growth-stage-major-stage">
          @for (stage of majorStages; track stage) {
            <div class="major-stage-option">
              <mat-radio-button [value]="stage" [disabled]="isMajorStageDisabled(stage)" color="primary">
                {{ getMajorStageKey(stage) | translate }}
              </mat-radio-button>
              <button
                mat-icon-button
                type="button"
                class="info-button"
                (click)="onInfoClicked(stage)"
                [matTooltip]="'downyMildew.growthPhase.showImage' | translate"
                data-test="growth-stage-info"
              >
                <mat-icon>info_outline</mat-icon>
              </button>
            </div>
          }
        </mat-radio-group>
      </div>

      <!-- Subphase selection -->
      <div class="spacing--margin-top">
        <div class="text--bold spacing--margin-half-bottom">
          {{ 'downyMildew.growthPhase.selectSubphase' | translate }}
        </div>
        <mat-form-field class="full-width-field" data-test="growth-stage-subphase">
          <mat-label>{{ 'downyMildew.growthPhase.selectSubphase' | translate }}</mat-label>
          <mat-select formControlName="subphase" class="subphase-group" [disabled]="filteredSubphases.length === 0">
            <mat-select-trigger>
              @if (form.controls.subphase.value; as selectedSubphase) {
                <span class="subphase-trigger">
                  <span class="subphase-code">{{ formatBbchDisplayCode(selectedSubphase.code3Digit) }}:</span>
                  <span class="subphase-description">{{ selectedSubphase.descriptionKey | translate }}</span>
                </span>
              }
            </mat-select-trigger>
            @for (subphase of filteredSubphases; track subphase.code3Digit) {
              <mat-option [value]="subphase" [disabled]="isSubphaseDisabled(subphase)" class="subphase-option">
                <span class="subphase-code">{{ formatBbchDisplayCode(subphase.code3Digit) }}:</span>
                <span class="subphase-description">{{ subphase.descriptionKey | translate }}</span>
              </mat-option>
            }
          </mat-select>
        </mat-form-field>

        <span [matTooltip]="'UI.CurrentYearOnlyMutationMessage' | translate" [matTooltipDisabled]="!isReadonlyMode">
          <button
            mat-flat-button
            color="accent"
            data-test="done-adding-product"
            type="button"
            (click)="submitGrowthStage()"
            [disabled]="isSubmitDisabled"
            class="spacing--margin-top spacing--margin-half-right"
          >
            @if (isSubmitting) {
              <mat-icon class="spinner">autorenew</mat-icon>
            }
            <mat-icon>add</mat-icon>
            {{ 'add' | translate }}
          </button>
        </span>
      </div>

      <!-- Validation message -->
      @if (isCodeTooLow) {
        <div class="validation-message spacing--margin-top" data-test="growth-stage-validation-error">
          <mat-icon class="validation-icon">warning</mat-icon>
          <span>{{ 'downyMildew.growthPhase.codeTooLow' | translate }}</span>
        </div>
      }
    </div>

    <mat-divider class="section-divider spacing--margin-top"></mat-divider>

    <div class="growth-stage-history-section spacing--margin-top">
      <div class="section-title spacing--margin-half-bottom">
        {{ 'downyMildew.growthStageHistory.title' | translate }}
      </div>
      <app-growth-stage-history
        [registrations]="downyMildewStore.growthStageHistoryValue()"
        [cropFields]="selectedCropFieldInfos"
        [isLoading]="downyMildewStore.growthStageHistoryIsLoading()"
        [readOnly]="isReadonlyMode"
        (removeRegistration)="onRemoveGrowthStage($event)"
      />
    </div>
  </div>
</agr-dialog>
